import { BookmarkCheck } from 'lucide-react'

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'

interface BookmarkIndicatorProps {
  readonly className?: string
}

export function BookmarkIndicator({
  className = 'h-5 w-5 text-foreground-fg-quaternary-400',
}: Readonly<BookmarkIndicatorProps>) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <BookmarkCheck className={className} />
        </TooltipTrigger>
        <TooltipContent>
          <span>Bookmarked</span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
